const FIELDS_TO_COMPARE = Object.freeze(['address1', 'address2', 'city', 'state', 'zip']);

export default function createPatientAddressFromState(patientState) {
  return FIELDS_TO_COMPARE.map(field => patientState[field])
    .map(e => e.trim())
    .filter(Boolean)
    .join(', ');
}
